import { PERFORMANCE_CONFIG, STATUS_VALIDATION_RULES } from "./config";

export enum IconType {
  ICON = "icon",
  HEADER_ICON = "headerIcon",
  BADGE_ICON = "badgeIcon",
  FILTER_ICON = "filterIcon",
}

// Status Management Constants
export const STATUS_CONSTANTS = {
  HIGHLIGHT_DURATION: PERFORMANCE_CONFIG.highlightDuration,
  DEFAULT_COLOR: "#6b7280",
  MIN_STATUS_NAME_LENGTH: STATUS_VALIDATION_RULES.minNameLength,
  MAX_STATUS_NAME_LENGTH: STATUS_VALIDATION_RULES.maxNameLength,
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  STATUS_NAME_REQUIRED: "Status name is required",
  STATUS_TYPE_REQUIRED: "Status type is required",
  STATUS_NOT_FOUND: "Status not found",
  STATUS_IN_USE: "Cannot delete status",
  CREATE_STATUS_FAILED: "Failed to create status",
  UPDATE_STATUS_FAILED: "Failed to update status",
  DELETE_STATUS_FAILED: "Failed to delete status",
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  STATUS_CREATED: "Status created successfully",
  STATUS_UPDATED: "Status updated successfully",
  STATUS_DELETED: "Status deleted successfully",
} as const;

// Type Mappings
export const STATUS_TYPE_MAPPING = {
  todo: "todo",
  "in-progress": "in-progress",
  "in-review": "in-review",
  backlog: "backlog",
  blocked: "blocked",
  done: "done",
  canceled: "canceled",
} as const;

// State Key to Status ID Mapping
export const STATE_KEY_TO_STATUS_ID = {
  BACKLOG: "backlog",
  TODO: "todo",
  IN_PROGRESS: "in-progress",
  IN_REVIEW: "in-review",
  BLOCKED: "blocked",
  DONE: "done",
  CANCELED: "canceled",
} as const;
